import React from 'react';
import EventEmitter, { EVENT_TYPES } from '@lib/eventEmitter';
import { scrollToElement } from '@lib/scroller';
import Modal from '@components/application/modal';
import { WithInstantSearchAnalytics } from '@javascript/types/InstantSearch';

type VideoLinksProps = {
  stockReference: string;
  isPhyronAvailable?: boolean;
  videoWalkaround?: string;
};

const VideoLinks = ({
  instantSearchAnalytics,
  isPhyronAvailable,
  stockReference,
  videoWalkaround,
}: VideoLinksProps & WithInstantSearchAnalytics) => {
  const scrollToVideoWalkaround = () => {
    const videoWalkaroundPanel = document.querySelector(
      '[data-element="video-walkaround"]',
    );
    scrollToElement(videoWalkaroundPanel);
  };

  const openVideoModal = () => {
    if (instantSearchAnalytics) {
      instantSearchAnalytics('click', 'Opens video tour');
    }

    EventEmitter.emit(EVENT_TYPES.openModal, `video_${stockReference}`);
  };

  if (!isPhyronAvailable && !videoWalkaround) return null;

  return (
    <>
      <button
        className="js-off--hide ac-imagethumbnail__video-link ch-rounded--sm ch-color--white ch-fs--1 ch-fw--500 ch-text-decoration--none"
        onClick={isPhyronAvailable ? openVideoModal : scrollToVideoWalkaround}
        type="button"
      >
        Video {isPhyronAvailable ? 'tour' : 'walkaround'}
      </button>
      {isPhyronAvailable && (
        <Modal id={`video_${stockReference}`}>
          <h2 className="ac-video-tour__load-message">Loading your video</h2>
          <div className="ac-video-tour">
            <div>
              <video
                className="phyron-video"
                data-campaign="arnoldclark"
                data-file="800x600"
                data-product-key={stockReference}
                data-tracking-source="phyron"
              ></video>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

VideoLinks.displayName = 'VideoLinks';

export default React.memo(VideoLinks);
